import { useContext } from './Context'
import { InputGroup } from 'react-bootstrap'

export const Layout = () => {
  const { components, ...context } = useContext()

  const { onRefresh, onAdd, onFilter, onSort, searchable, containerStyle } = context ?? {}
  let refreshComponent, addComponent, filterComponent, sortComponent, searchComponent
  const otherComponent = <components.other {...context} />

  if (onRefresh) {
    refreshComponent = <components.refresh {...context} />
  }
  if (onAdd) {
    addComponent = <components.add {...context} />
  }

  if (onFilter) {
    filterComponent = <components.filter {...context} />
  }

  if (onSort) {
    sortComponent = <components.sort {...context} />
  }

  if (searchable) {
    searchComponent = <components.search {...context} />
  }

  return (
    <InputGroup style={{ ...containerStyle }}>
      {otherComponent}
      {addComponent}
      {refreshComponent}
      {filterComponent}
      {sortComponent}
      {searchComponent}
    </InputGroup>
  )
}
